(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_color-variants"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    const thumb = e.target.closest('.color-variants__thumbnail');
    if (!thumb || thumb.classList.contains('color-variants__thumbnail--active')) return;

    e.preventDefault();
    window.location.replace(thumb.href);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_multipack-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    const pill = e.target.closest('.multipack-selector__pill');
    if (!pill || pill.classList.contains('multipack-selector__pill--active')) return;

    e.preventDefault();
    window.location.replace(pill.href);
  });
  } catch(e) { console.error(e); }
})();

})();
